<template>
  <div class="content-body">
    <div class="container">
      <div class="col-xxl-12">
        <p>SVC Total max. supply: <strong>210 million</strong></p>
        <div>
          <h2>Reaperville Staking Statistics</h2>
          <h4 class="mt-4">Earnable reward tokens:</h4>
          <ul>
            <li>
              <strong>5 million in total for Reaperville</strong>
            </li>
            <li>
              <p>1 million in first year</p>
            </li>
            <li>
              <p>2.5 million in first 3 years</p>
            </li>
          </ul>
          <h4 class="mt-4">
            <p>
              Total staked power:
              <strong>{{ formatNumber(totalStakedPower, 3) }}</strong>
            </p>
            <p>
              Base staking power:
              <strong
                >{{ formatNumber(baseStakingPower, 3) }} ==
                {{
                  Math.round((baseStakingPower / totalStakedPower) * 10000) /
                  100
                }}%</strong
              >
            </p>
          </h4>
          <p>Stake and upgrade add 1% to base staking power</p>
          <p>Unstake adds 5% to base staking power</p>
          <p>Emergency unstake adds 0% to base staking power</p>
          <h4>
            <p>
              Reward tokens minted:
              <strong
                >{{
                  formatNumber(
                    Math.round(
                      (5 * 10 ** 24 -
                        Number(tokenMintAllowanceE0[("svc", "reaper")])) /
                        10 ** 18
                    ),
                    3
                  )
                }}
                SVC</strong
              >
            </p>
            <p>
              Reaperville total emission rate:
              <strong
                >{{ formatNumber(rewardTokenEmissionPerHourE18, 3) }} SVC / hour
                @100% payout</strong
              >
            </p>
            <p>
              =
              {{ formatNumber(rewardTokenEmissionPerHourE18 * 24 * 365, 3) }}
              SVC / year
            </p>
          </h4>

          <hr class="mt-4 mb-4" />

          <h1 class="mx-auto mb-0 mt-4 animate-characters">
            Everything below is ADMIN ONLY
          </h1>
          <br />
          <h2 v-if="!userIsAdmin" class="mx-auto mt-0 mb-4 animate-characters">
            (You are not logged into the admin wallet)
          </h2>
          <h2 v-else class="mx-auto mt-0 mb-4 animate-characters">
            (YOU ARE THE ADMIN)
          </h2>

          <hr class="mt-4 mb-4" />

          <h2>Reward Token SVC</h2>
          Update allowance of {{ newMinterAddress }} to
          {{
            formatNumber(
              tokenMintAllowanceE0[("svc", "newMinter")] / 10 ** 18,
              3
            )
          }}
          SVC =
          {{
            formatNumber(
              tokenMintAllowanceE0[("svc", "newMinter")] / 10 ** 18,
              3
            )
          }}
          SVC
          <input
            type="text"
            class="form-control mx-auto"
            v-model="tokenMintAllowanceE0[('svc', 'newMinter')]"
          />
          <input
            id="newMinterAddress"
            type="text"
            class="form-control mx-auto"
            v-model="newMinterAddress"
          />

          <button
            class="btn btn-success"
            :disabled="!userIsAdmin"
            @click="getTokenMintAllowance('svc', 'newMinter')"
          >
            Load allowance of {{ newMinterAddress }}
          </button>

          &nbsp;

          <button
            class="btn btn-danger"
            :disabled="!userIsAdmin"
            @click="
              setMintAllowanceByCa(
                newMinterAddress,
                tokenMintAllowanceE0[('svc', 'newMinter')]
              )
            "
          >
            Update allowance to
            {{
              formatNumber(
                tokenMintAllowanceE0[("svc", "newMinter")] / 10 ** 18,
                3
              )
            }}
            SVC
          </button>

          &nbsp;

          <button
            class="btn btn-std"
            v-if="userIsAdmin"
            @click="
              mintRewardToken(
                newMinterAddress,
                tokenMintAllowanceE0[('svc', 'newMinter')]
              )
            "
          >
            Mint
            {{
              formatNumber(
                tokenMintAllowanceE0[("svc", "newMinter")] / 10 ** 18,
                3
              )
            }}
            SVC
          </button>

          <hr />

          <h2>Card Game Contract Balances</h2>
          <p>
            {{ formatNumber(bchBalanceE0["cards"] / 10 ** 18, 3) }}
            {{ ETH }}
          </p>
          <p>
            {{ formatNumber(tokenBalanceE0[("svc", "cards")] / 10 ** 18, 3) }}
            SVC
          </p>
          <div>
            <button
              class="btn btn-std"
              type="button"
              :disabled="bchBalanceE0['cards'] <= 0 || !userIsAdmin"
              @click="withdrawBchFromContract('cards')"
            >
              withdraw all {{ ETH }}
            </button>

            &nbsp;

            <button
              class="btn btn-danger"
              type="button"
              :disabled="tokenBalanceE0[('svc', 'cards')] <= 0 || !userIsAdmin"
              @click="withdrawTokenFromContract('svc', 'cards')"
            >
              withdraw all SVC
            </button>
          </div>

          <div class="mt-4">
            <h6>Specify SVC to send to or withdraw from the cards contract</h6>
            <input
              type="number"
              class="form-control mx-auto"
              v-model="svc2WithdrawOrSendE18"
            />
            <button
              class="btn btn-std"
              type="button"
              :disabled="tokenBalanceE0[('svc', 'cards')] <= 0 || !userIsAdmin"
              @click="withdrawSvcFromCards(svc2WithdrawOrSendE18)"
            >
              withdraw {{ formatNumber(svc2WithdrawOrSendE18, 3) }} SVC
            </button>

            &nbsp;

            <button
              class="btn btn-std"
              type="button"
              :disabled="tokenBalanceE0[('svc', 'user')] <= 0"
              @click="sendSvcToCards(svc2WithdrawOrSendE18)"
            >
              send {{ formatNumber(svc2WithdrawOrSendE18, 3) }} SVC
            </button>

            <br />

            Your wallet holds
            {{ formatNumber(tokenBalanceE0[("svc", "user")] / 10 ** 18, 3) }}
            SVC
          </div>

          <div>
            <h4 class="mt-4">Reset Cards Contract</h4>
            <p>Make sure the contract holds at least 90626 SVC</p>
            <p>Contract address: {{ cardsCa }}</p>
            <button
              class="btn btn-danger"
              type="button"
              :disabled="!userIsAdmin"
              @click="resetContract('cards')"
            >
              Reset contract for new round
            </button>
          </div>

          <br />

          <h2 class="mb-0">Reaperville Contract</h2>
          <div>
            Reaperville contract can still mint
            <strong>
              {{
                formatNumber(
                  tokenMintAllowanceE0[("svc", "reaper")] / 10 ** 18,
                  3
                )
              }}
            </strong>
            SVC
          </div>
          <input
            type="text"
            class="form-control mx-auto"
            v-model="tokenMintAllowanceE0[('svc', 'reaper')]"
          />
          <div>
            <button
              class="btn btn-success"
              :disabled="!userIsAdmin"
              @click="getTokenMintAllowance('svc', 'reaper')"
            >
              Load allowance of Reaperville
            </button>

            &nbsp;

            <button
              class="btn btn-danger"
              :disabled="!userIsAdmin"
              @click="
                setMintAllowance(
                  'reaper',
                  tokenMintAllowanceE0[('svc', 'reaper')]
                )
              "
            >
              Update allowance to
              {{
                formatNumber(
                  tokenMintAllowanceE0[("svc", "reaper")] / 10 ** 18,
                  3
                )
              }}
              SVC
            </button>
          </div>

          <br />

          <h4>Reaper Contract Balances</h4>
          <p>
            {{ formatNumber(bchBalanceE0["reaper"] / 10 ** 18, 3) }}
            {{ ETH }}
          </p>
          <div>
            <button
              class="btn btn-std"
              type="button"
              :disabled="bchBalanceE0['reaper'] <= 0 || !userIsAdmin"
              @click="withdrawBchFromContract('reaper')"
            >
              withdraw {{ ETH }}
            </button>
          </div>

          <br />

          <h4>Reaper Mint Price</h4>
          <p>
            {{ formatNumber(bchPerNftE0 / 10 ** 18, 6) }}
            {{ ETH }}
          </p>
          <input
            id="bchPerNftE0"
            type="text"
            class="form-control mx-auto"
            v-model="bchPerNftE0"
          />
          <div>
            <button
              class="btn btn-std"
              :disabled="!userIsAdmin"
              type="button"
              @click="setBchPerNftE0('reaper')"
            >
              set new price
              {{ formatNumber(bchPerNftE0 / 10 ** 18, 3) }} {{ ETH }}
            </button>
          </div>

          <br />

          <h2 class="mb-0">Pause Reaper Mint</h2>
          Mint is active: {{ !mintPaused }}
          <p>
            <button
              @click="setNftMintPaused(true)"
              :disabled="mintPaused || !userIsAdmin"
              class="btn btn-danger"
            >
              Pause
            </button>
            &nbsp;
            <button
              @click="setNftMintPaused(false)"
              :disabled="!mintPaused || !userIsAdmin"
              class="btn btn-success"
            >
              Unpause
            </button>
          </p>

          <h2 class="mb-0">Pause Reaper Staking</h2>
          Staking is active: {{ !stakingPaused }}
          <p>
            <button
              @click="setNftStakingPaused('reaper', true)"
              :disabled="stakingPaused || !userIsAdmin"
              class="btn btn-danger"
            >
              Pause
            </button>
            &nbsp;
            <button
              @click="setNftStakingPaused('reaper', false)"
              :disabled="!stakingPaused || !userIsAdmin"
              class="btn btn-success"
            >
              Unpause
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="popup" v-if="txInProgress || feedbackMessage != ''">
    <div
      class="popupX"
      @click="
        feedbackMessage = '';
        txInProgress = false;
      "
    >
      x
    </div>
    <h4 v-if="feedbackMessage != ''" class="text-monospace animate-popup">
      {{ feedbackMessage }}
    </h4>
    <br />
    <h5 v-if="txInProgress" class="text-monospace animate-popup">
      Waiting for current transaction to finish...
    </h5>
  </div>
</template>

<script>
import { ethers } from "ethers";
import RewardToken from "../../artifacts/contracts/RewardToken.sol/RewardToken.json";
import Reaperville from "../../artifacts/contracts/Reaperville.sol/Reaperville.json";
import Cards from "../../artifacts/contracts/Cards.sol/Cards.json";

export default {
  name: "App",
  components: {},

  data() {
    return {
      contracts: {},

      newMinterAddress: "",

      ETH: window.ETH,

      userIsAdmin: false,
      userAddress: null,

      // contracts
      bchBalanceE0: {},
      tokenMintAllowanceE0: {},
      tokenBalanceE0: {},
      svc2WithdrawOrSendE18: 1000,

      // staking Reapers
      stakingPaused: false,
      totalStakedPower: 0,
      baseStakingPower: 0,
      rewardTokenEmissionPerHourE18: 0,

      // nft minting
      mintPaused: false,
      bchPerNftE0: "0",

      cardsCa: window.ca["cards"],

      feedbackMessage: "",
      txInProgress: false,
    };
  },
  methods: {
    setFeedback: function (_text, _timeOut) {
      let that = this;
      that.feedbackMessage = _text;
      if (that.lastTimeout > 0) {
        clearTimeout(that.lastTimeout);
      }
      if (_timeOut > 0) {
        that.lastTimeout = setTimeout(function () {
          that.feedbackMessage = "";
        }, _timeOut);
      }
    },

    formatNumber: function (_number, _decimals) {
      _number = Number(_number);
      if (_number < 1) {
        return String(_number);
      }

      const _symbols = ["", "k", "M", "G", "T"];
      let returnString = "";
      for (let _idx = _symbols.length - 1; _idx >= 0; --_idx) {
        const _exp = 3 * _idx;
        const _testNumber = _number / 10 ** _exp;
        if (_testNumber >= 1) {
          // get rid off unnecessary decimals
          const _intLength = String(Math.round(_testNumber)).length;
          _number =
            Math.round(_number * 10 ** (_decimals + _intLength + _exp)) /
            10 ** (_decimals + _intLength + _exp);

          returnString =
            Math.floor(_number / 10 ** (_exp - _decimals)) / 10 ** _decimals +
            _symbols[_idx];
          return returnString;
        }
      }
    },

    mintRewardToken: async function (newMinterAddress, amount) {
      let tx = await this.contracts["svc"].mint(
        newMinterAddress,
        amount.toString()
      );
      await tx.wait();
    },

    setNftMintPaused: async function (newPaused) {
      let tx = await this.contracts["reaper"].setMintPaused(newPaused);
      await tx.wait();
      window.location.reload();
    },

    setNftStakingPaused: async function (_contractName, _newPaused) {
      let tx = await this.contracts[_contractName].setStakingPaused(_newPaused);
      await tx.wait();
      window.location.reload();
    },

    setBchPerNftE0: async function (_contractName) {
      let tx = await this.contracts[_contractName].setBchPerNft(
        String(this.bchPerNftE0)
      );
      await tx.wait();
      window.location.reload();
    },

    withdrawBchFromContract: async function (_contractName) {
      let tx = await this.contracts[_contractName].withdrawBch();
      await tx.wait();
      window.location.reload();
    },

    withdrawTokenFromContract: async function (_tokenName, _contractName) {
      let tx = await this.contracts[_contractName].withdrawToken(
        window.ca[_tokenName]
      );
      await tx.wait();
      window.location.reload();
    },

    withdrawSvcFromCards: async function (_amountE18) {
      const _amountE0 = _amountE18.toString() + "000000000000000000";
      let tx = await this.contracts["cards"].withdrawSvc(_amountE0);
      await tx.wait();
      window.location.reload();
    },

    sendSvcToCards: async function (_amountE18) {
      const _amountE0 = _amountE18.toString() + "000000000000000000";
      let tx = await this.contracts["svc"].transfer(
        window.ca["cards"],
        _amountE0
      );
      await tx.wait();
      window.location.reload();
    },

    resetContract: async function (_contractName) {
      console.log(this.tokenBalanceE0[("svc", "cards")].slice(0, 5));
      console.log(this.tokenBalanceE0[("svc", "cards")].length);

      let balanceLength = this.tokenBalanceE0[("svc", "cards")].length;
      if (
        balanceLength < 23 ||
        Number(
          this.tokenBalanceE0[("svc", "cards")].slice(0, balanceLength - 18)
        ) < 90626
      ) {
        this.setFeedback("not enough SVC on contract", 2000);
        return false;
      }

      let tx = await this.contracts[_contractName].reset();
      await tx.wait();
      window.location.reload();
    },

    setMintAllowanceByCa: async function (_address, _newAllowance) {
      let tx;
      if (_newAllowance === 0) {
        tx = await this.contracts["svc"].removeMinter(_address);
      } else {
        tx = await this.contracts["svc"].updateMintersAllowance(
          _address,
          _newAllowance
        );
      }
      await tx.wait();
      window.location.reload();
    },

    setMintAllowance: async function (_addressName, _newAllowance) {
      let _contractAddress =
        _addressName === "newMinter"
          ? this.newMinterAddress
          : window.ca[_addressName];

      this.setMintAllowanceByCa(_contractAddress, _newAllowance);
    },

    getTokenMintAllowance: async function (_tokenName, _addressName) {
      let _ca = window.ca[_addressName];
      if (_addressName === "newMinter") {
        _ca = this.newMinterAddress;
      }

      this.contracts[_tokenName]
        .remainingMintersAllowance(_ca)
        .then((_allowance) => {
          this.tokenMintAllowanceE0[(_tokenName, _addressName)] =
            String(_allowance);
        });
    },

    getTokenBalance: async function (_tokenName, _addressName) {
      this.contracts[_tokenName]
        .balanceOf(window.ca[_addressName])
        .then((_balance) => {
          this.tokenBalanceE0[(_tokenName, _addressName)] = String(_balance);
        });
    },

    getBchBalance: async function (_addressName) {
      this.provider.getBalance(window.ca[_addressName]).then((balance) => {
        this.bchBalanceE0[_addressName] = String(balance);
      });
    },
  },

  mounted: function () {
    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");

    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();

        this.contracts["svc"] = new ethers.Contract(
          window.ca["svc"],
          RewardToken.abi,
          this.signer
        );

        this.contracts["reaper"] = new ethers.Contract(
          window.ca["reaper"],
          Reaperville.abi,
          this.signer
        );

        this.contracts["cards"] = new ethers.Contract(
          window.ca["cards"],
          Cards.abi,
          this.signer
        );

        // this.flexUsdTokenContract = new ethers.Contract(
        //   window.FlexUsdAddress,
        //   RewardToken.abi,
        //   this.signer
        // );
      })
      .then(() => {
        this.signer
          .getAddress()
          .then((address) => {
            this.userAddress = address;

            if (address === window.ca["dev"]) {
              this.userIsAdmin = true;
            }

            this.newMinterAddress = address;

            this.getTokenMintAllowance("svc", "newMinter");
          })
          .then(() => {
            this.contracts["svc"]
              .balanceOf(this.userAddress)
              .then((_balance) => {
                this.tokenBalanceE0[("svc", "user")] = String(_balance);
              });
          });

        this.contracts["reaper"]
          .showStakerInfo(window.ca["dev"])
          .then((stakerInfo) => {
            this.totalStakedPower = stakerInfo[2];
            this.baseStakingPower = stakerInfo[3];
            this.rewardTokenEmissionPerHourE18 = String(
              Math.round(ethers.utils.formatEther(stakerInfo[4]) * 100000) /
                100000
            );
          });

        // token balances
        const _contractsToLoad = ["reaper", "cards"];
        for (let _contract of _contractsToLoad) {
          this.getBchBalance(_contract);
          this.getTokenBalance("svc", _contract);
        }
        this.getTokenMintAllowance("svc", "reaper");

        this.contracts["reaper"].isMintPausedStakingPaused().then((result) => {
          this.mintPaused = result[0];
          this.stakingPaused = result[1];
        });

        this.contracts["reaper"].bchPerNft().then((_bchPerNft) => {
          this.bchPerNftE0 = String(_bchPerNft);
        });
      });
  },
};
</script>
